import { createClient } from '@jsr/supabase__supabase-js';

// Scrub literal "\n" and surrounding whitespace that can leak into env vars
// when they're added to Vercel via piped input (same hygiene as src/config/auth.ts).
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.replace(/\\n/g, '').trim();
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.replace(/\\n/g, '').trim();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env.local file.\n' +
    'Required: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
